




























































































































































import Vue from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "SingleSchool",
  data() {
    return {
      organization: {},
      edit: false,
      admins: [],
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: Number,
  },
  methods: {
    startEditing() {
      this.edit = true;
    },
    editOrganization() {
      this.$emit("close");
      this.$router.push("/members/organization/" + this.id);
      // this.$router.push({
      //   name: "Edit Organization",
      //   params: { organization_id: this.id },
      // });
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
  },
  mounted() {
    ApiService.generalApi.getOrganization(this.id).then((resp) => {
      this.organization = resp.data;
    });
  },
});
